export const extraCategoriesRaw = {
  packs: {
    nameKey: "extras.categories.packs", // Key for the category title itself
    items: [
      {
        id: "packEssentiel",
        name: "extras.packs.essential.name", // i18n key
        defaultName: "The Essential (for 2)",
        defaultFrenchName: "L'essentiel (pour 2)",
        descriptionKey: "extras.packs.essential.description",
        price: 85,
        extraPersonPrice: 20,
        imageIdentifier: "essentiel",
        typeKey: "extras.types.pack",
      },
      {
        id: "packDetenteGourmet",
        name: "extras.packs.relaxGourmet.name",
        defaultName: "Gourmet Relaxation (for 2)",
        defaultFrenchName: "Le détente gourmet (pour 2)",
        descriptionKey: "extras.packs.relaxGourmet.description",
        price: 150,
        extraPersonPrice: 40,
        imageIdentifier: "detente",
        typeKey: "extras.types.pack",
      },
      {
        id: "packRomantiqueGourmet",
        name: "extras.packs.romanticGourmet.name",
        defaultName: "Romantic Gourmet (for 2)",
        defaultFrenchName: "Le romantique gourmet (pour 2)",
        descriptionKey: "extras.packs.romanticGourmet.description",
        price: 170,
        extraPersonPrice: 40,
        imageIdentifier: "romantiquegourmet",
        typeKey: "extras.types.pack",
      },
      {
        id: "packRacletteDetente",
        name: "extras.packs.racletteRelax.name",
        defaultName: "Raclette Relaxation (for 2)",
        defaultFrenchName: "La raclette en détente (pour 2)",
        descriptionKey: "extras.packs.racletteRelax.description",
        price: 150,
        extraPersonPrice: 40,
        imageIdentifier: "raclettedetente",
        typeKey: "extras.types.pack",
      },
      {
        id: "packRacletteRomantique",
        name: "extras.packs.racletteRomantic.name",
        defaultName: "Romantic Raclette (for 2)",
        defaultFrenchName: "La raclette romantique (pour 2)",
        descriptionKey: "extras.packs.racletteRomantic.description",
        price: 170,
        extraPersonPrice: 40,
        imageIdentifier: "racletteromantique",
        typeKey: "extras.types.pack",
      },
      {
        id: "packBbqDetente",
        name: "extras.packs.bbqRelax.name",
        defaultName: "BBQ Relaxation (for 2)",
        defaultFrenchName: "Le barbecue détente (pour 2)",
        descriptionKey: "extras.packs.bbqRelax.description",
        price: 150,
        extraPersonPrice: 40,
        imageIdentifier: "barbecuedetente",
        typeKey: "extras.types.pack",
      },
      {
        id: "packBbqRomantique",
        name: "extras.packs.bbqRomantic.name",
        defaultName: "Romantic BBQ (for 2)",
        defaultFrenchName: "Le romantique barbecue (pour 2)",
        descriptionKey: "extras.packs.bbqRomantic.description",
        price: 170,
        extraPersonPrice: 40,
        imageIdentifier: "barbecueromantique",
        typeKey: "extras.types.pack",
      },
    ],
  },
  formulesRepas: {
    nameKey: "extras.categories.formulesRepas",
    items: [
      {
        id: "formulePetitDej",
        name: "extras.formulesRepas.breakfast.name",
        defaultName: "Breakfast Formula (2 ppl)",
        defaultFrenchName: "Formule petit-déjeuner (2 pers)",
        descriptionKey: "extras.formulesRepas.breakfast.description",
        price: 35,
        extraPersonPrice: 10,
        imageIdentifier: "formuledejeuner",
        typeKey: "extras.types.formula",
      },
      {
        id: "formuleGourmet",
        name: "extras.formulesRepas.gourmet.name",
        defaultName: "Gourmet Formula (2 ppl)",
        defaultFrenchName: "Formule gourmet (2 pers)",
        descriptionKey: "extras.formulesRepas.gourmet.description",
        price: 85,
        extraPersonPrice: 20,
        imageIdentifier: "formulegourmet",
        typeKey: "extras.types.formula",
      },
      {
        id: "formulePancheApero",
        name: "extras.formulesRepas.apero.name",
        defaultName: "Aperitif Platter Formula (2 ppl)",
        defaultFrenchName: "Formule planche apéro (2 pers)",
        descriptionKey: "extras.formulesRepas.apero.description",
        price: 30,
        imageIdentifier: "plancheapero",
        typeKey: "extras.types.formula",
      },
      {
        id: "formuleRaclette",
        name: "extras.formulesRepas.raclette.name",
        defaultName: "Raclette Formula (2 ppl)",
        defaultFrenchName: "Formule raclette (2 pers)",
        descriptionKey: "extras.formulesRepas.raclette.description",
        price: 85,
        extraPersonPrice: 20,
        imageIdentifier: "raclette",
        typeKey: "extras.types.formula",
      },
      {
        id: "formuleBarbecue",
        name: "extras.formulesRepas.barbecue.name",
        defaultName: "Barbecue Formula (2 ppl)",
        defaultFrenchName: "Formule barbecue (2 pers)",
        descriptionKey: "extras.formulesRepas.barbecue.description",
        price: 85,
        extraPersonPrice: 20,
        imageIdentifier: "babrecue",
        typeKey: "extras.types.formula",
      },
    ],
  },
  spa: {
    nameKey: "extras.categories.spa",
    items: [
      {
        id: "formuleSpa",
        name: "extras.spa.basic.name",
        defaultName: "SPA Formula (2 ppl)",
        defaultFrenchName: "Formule SPA (2 pers)",
        descriptionKey: "extras.spa.basic.description",
        price: 50,
        extraPersonPrice: 10,
        imageIdentifier: "formulespa",
        typeKey: "extras.types.formula",
      },
      {
        id: "formuleSpaBottle",
        name: "extras.spa.withBottle.name",
        defaultName: "SPA Formula + Bottle (2 ppl)",
        defaultFrenchName: "Formule SPA + bouteille (2 pers)",
        descriptionKey: "extras.spa.withBottle.description",
        price: 90,
        imageIdentifier: "spabouteille",
        typeKey: "extras.types.formula",
      },
    ],
  },
  formulesDécouvertes: {
    nameKey: "extras.categories.formulesDecouverte",
    items: [
      {
        id: "packPassion",
        name: "extras.formulesDecouverte.passion.name",
        defaultName: "Passion Formula (for 2)",
        defaultFrenchName: "Formule passion (pour 2)",
        descriptionKey: "extras.formulesDecouverte.passion.description",
        price: 50,
        imageIdentifier: "passion",
        typeKey: "extras.types.pack",
      },
      {
        id: "packAnniversaire",
        name: "extras.formulesDecouverte.birthday.name",
        defaultName: "Birthday Formula (2 ppl)",
        defaultFrenchName: "Formule anniversaire (pour 2)",
        descriptionKey: "extras.formulesDecouverte.birthday.description",
        price: 55,
        extraPersonPrice: 5,
        imageIdentifier: "formuleanniversaire",
        typeKey: "extras.types.pack",
      },
    ],
  },
  meals: {
    nameKey: "extras.categories.meals",
    items: [
      {
        id: "meatballsLiege",
        name: "extras.meals.meatballsLiege.name",
        defaultName: "Liege Style Meatballs",
        defaultFrenchName: "Boulettes de viande sauce liégeoise",
        descriptionKey: "extras.meals.meatballsLiege.description",
        price: 15,
        imageIdentifier: "bouletteLiege",
        typeKey: "extras.types.meal",
      },
      {
        id: "meatballsTomato",
        name: "extras.meals.meatballsTomato.name",
        defaultName: "Meatballs in Tomato Sauce",
        defaultFrenchName: "Boulette de viande sauce tomate",
        descriptionKey: "extras.meals.meatballsTomato.description",
        price: 15,
        imageIdentifier: "bouletteTomate",
        typeKey: "extras.types.meal",
      },
      {
        id: "waterzooi",
        name: "extras.meals.waterzooi.name",
        defaultName: "Chicken Waterzooi",
        defaultFrenchName: "Waterzooi de volaille",
        descriptionKey: "extras.meals.waterzooi.description",
        price: 15,
        imageIdentifier: "waterzooi",
        typeKey: "extras.types.meal",
      },
      {
        id: "chiliVeg",
        name: "extras.meals.chiliVeg.name",
        defaultName: "Vegetarian Chili",
        defaultFrenchName: "Chili végétarien",
        descriptionKey: "extras.meals.chiliVeg.description",
        price: 15,
        imageIdentifier: "chiliVeg",
        typeKey: "extras.types.meal",
      },
      {
        id: "carrotSoup",
        name: "extras.meals.carrotSoup.name",
        defaultName: "Carrot and Cumin Soup",
        defaultFrenchName: "Velouté de carotte et cumin",
        descriptionKey: "extras.meals.carrotSoup.description",
        price: 5,
        imageIdentifier: "veloute",
        typeKey: "extras.types.meal",
      },
    ],
  },
  boissons: {
    nameKey: "extras.categories.boissons",
    items: [
      {
        id: "brutBioul",
        name: "drinkNames.brutBioul",
        defaultName: "Brut de Bioul (Sparkling)",
        defaultFrenchName: "Brut de Bioul",
        descriptionKey: "extras.drinks.brutBioul.description",
        price: 50,
        imageIdentifier: "brutBioul",
        typeKey: "extras.drinkTypes.bulles",
      },
      {
        id: "cortilBarco",
        name: "drinkNames.cortilBarco", // i18n Key
        defaultName: "Cortil Barco (Red Wine)",
        defaultFrenchName: "Cortil Barco (rouge)",
        descriptionKey: "extras.drinks.cortilBarco.description",
        price: 30,
        imageIdentifier: "cortilBarco",
        typeKey: "extras.drinkTypes.wine",
      },
      {
        id: "terreCharlot",
        name: "drinkNames.terreCharlot", // i18n Key
        defaultName: "Terre Charlot (White Wine)",
        defaultFrenchName: "Terre Charlot (blanc)",
        descriptionKey: "extras.drinks.terreCharlot.description",
        price: 30,
        imageIdentifier: "terreCharlot",
        typeKey: "extras.drinkTypes.wine",
      },
      {
        id: "bruneCondroz",
        name: "drinkNames.bruneCondroz", // i18n Key
        defaultName: "Brune du Condroz (Beer)",
        defaultFrenchName: "Brune du Condroz",
        descriptionKey: "extras.drinks.bruneCondroz.description",
        price: 4,
        imageIdentifier: "bruneCondroz",
        typeKey: "extras.drinkTypes.beer",
      },
      {
        id: "ambreeCondroz",
        name: "drinkNames.ambreeCondroz", // i18n Key
        defaultName: "Ambrée du Condroz (Beer)",
        defaultFrenchName: "Ambrée du Condroz",
        descriptionKey: "extras.drinks.ambreeCondroz.description",
        price: 4,
        imageIdentifier: "ambreeCondroz",
        typeKey: "extras.drinkTypes.beer",
      },
      {
        id: "tripleCondroz",
        name: "drinkNames.tripleCondroz", // i18n Key
        defaultName: "Triple du Condroz (Beer)",
        defaultFrenchName: "Triple du Condroz",
        descriptionKey: "extras.drinks.tripleCondroz.description",
        price: 4,
        imageIdentifier: "tripleCondroz",
        typeKey: "extras.drinkTypes.beer",
      },
      {
        id: "blancheCondroz",
        name: "drinkNames.blancheCondroz", // i18n Key
        defaultName: "Blanche du Condroz (Beer)",
        defaultFrenchName: "Blanche du Condroz",
        descriptionKey: "extras.drinks.blancheCondroz.description",
        price: 4,
        imageIdentifier: "blancheCondroz",
        typeKey: "extras.drinkTypes.beer",
      },
      {
        id: "appleJuice",
        name: "drinkNames.appleJuice", // i18n Key
        defaultName: 'Apple Juice "Pom d\'Happy"',
        defaultFrenchName: "Jus de pomme « Pom d'Happy »",
        descriptionKey: "extras.drinks.appleJuice.description",
        price: 3,
        imageIdentifier: "pomHappy",
        typeKey: "extras.drinkTypes.soft",
      },
      {
        id: "ritchieLemonRasp",
        name: "drinkNames.ritchieLemonRasp", // i18n Key
        defaultName: "Ritchie Lemon/Raspberry",
        defaultFrenchName: "Ritchie Citron/Framboise",
        descriptionKey: "extras.drinks.ritchieLemonRasp.description",
        price: 3,
        imageIdentifier: "ritchieCitronFramboise",
        typeKey: "extras.drinkTypes.soft",
      },
      {
        id: "ritchieOrangeVan",
        name: "drinkNames.ritchieOrangeVan", // i18n Key
        defaultName: "Ritchie Orange/Vanilla",
        defaultFrenchName: "Ritchie Orange/Vanille",
        descriptionKey: "extras.drinks.ritchieOrangeVan.description",
        price: 3,
        imageIdentifier: "ritchieOrange",
        typeKey: "extras.drinkTypes.soft",
      },
      {
        id: "ritchieCola",
        name: "drinkNames.ritchieCola", // i18n Key
        defaultName: "Ritchie Cola",
        defaultFrenchName: "Ritchie Cola",
        descriptionKey: "extras.drinks.ritchieCola.description",
        price: 3,
        imageIdentifier: "ritchieCola",
        typeKey: "extras.drinkTypes.soft",
      },
      {
        id: "ritchieColaZero",
        name: "drinkNames.ritchieColaZero", // i18n Key
        defaultName: "Ritchie Cola Zero",
        defaultFrenchName: "Ritchie Cola Zéro",
        descriptionKey: "extras.drinks.ritchieColaZero.description",
        price: 3,
        imageIdentifier: "ritchieColaZero",
        typeKey: "extras.drinkTypes.soft",
      },
    ],
  },
};

export const ALL_DRINK_ITEMS_MAP_RAW = extraCategoriesRaw.boissons.items.reduce(
  (acc, item) => {
    acc[item.id] = item; // item now contains 'name' as i18n key, and default names
    return acc;
  },
  {}
);

export const DRINK_OFFER_CONFIG_RAW = {
  WINE_OFFER_1: {
    key: "WINE_OFFER_1",
    titleKey: "extras.drinks.wineOfferTitle", // This is an i18n key for the offer title
    defaultTitle: "Choix de Vin Inclus (1 bouteille)", // Fallback French title
    triggeringExtras: [
      "formuleGourmet",
      "formuleRaclette",
      "formuleBarbecue",
      "packDetenteGourmet",
      "packRacletteDetente",
      "packBbqRomantique",
      "packBbqDetente",
    ],
    drinks: [
      // For radio button display on client - these nameKeys should match individual drink keys
      {
        id: "cortilBarco",
        nameKey: "drinkNames.cortilBarco",
        defaultName: "Cortil Barco (rouge)",
      },
      {
        id: "terreCharlot",
        nameKey: "drinkNames.terreCharlot",
        defaultName: "Terre Charlot (blanc)",
      },
    ],
    maxSelection: 1,
    type: "wine_choice",
  },
  SOFTS_BEERS_OFFER_1: {
    key: "SOFTS_BEERS_OFFER_1",
    titleKey: "extras.drinks.softBeerOfferTitle",
    defaultTitle: "Choix de Boissons",
    triggeringExtras: ["formulePancheApero"],
    categories: {
      softs: extraCategoriesRaw.boissons.items
        .filter((item) => item.typeKey === "extras.drinkTypes.soft")
        .map((item) => item.id),
      beers: extraCategoriesRaw.boissons.items
        .filter((item) => item.typeKey === "extras.drinkTypes.beer")
        .map((item) => item.id),
    },
    itemsPerUnit: 2,
    itemsPerSupplementaryPerson: 1,
    type: "soft_beer_choice",
  },
};

export const getExtraByIdRaw = (id) => {
  if (!id) return null;
  for (const categoryKey in extraCategoriesRaw) {
    const category = extraCategoriesRaw[categoryKey];
    if (category.items && Array.isArray(category.items)) {
      const item = category.items.find(
        (item) => String(item.id) === String(id)
      );
      if (item) return item;
    }
  }
  return null;
};

export const calculateExtrasTotalRaw = (selectedExtras) => {
  /* ... as before ... */
  if (!selectedExtras || typeof selectedExtras !== "object") return 0;
  return Object.entries(selectedExtras).reduce((total, [extraId, quantity]) => {
    const extra = getExtraByIdRaw(extraId);
    const numQuantity = Number(quantity) || 0;
    return total + (extra?.price || 0) * numQuantity;
  }, 0);
};
